export default __webpack_public_path__ + "static/media/image-chair-child-w@2x.864a0bc0.webp";